import React from 'react'

const DL950 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Yokogawa</a>
                        <i class="fa fa-angle-right"></i>
                        <a href="/">Oscilloscopes</a>
                        <i class="fa fa-angle-right"></i>
                        <span>ScopeCorder </span>
                        <i class="fa fa-angle-right"></i>
                        <span>DL950 </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/dl950.png' width={400} style={{ marginTop: "80px" }}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>DL950:</h2>
                        <p className="mbot25">
                            The DL950 is a unique combination of a mixed signal oscilloscope
                            and portable data acquisition recorder that can be used to capture both
                            high speed transient events and long run trends.
                        </p>
                        <p className="mbot25">New high-speed module and 10 Gbps Ethernet
                            200 MS/s 14 Bit Isolation Module</p>
                        <p className="mbot25">Accurately captures switching waveforms of inverters and fastmoving
                            noises around the power supply.</p>
                        <p class="mbot25">
                            <ul>
                                <li>Isolated input of up to 1000 V</li>
                                <li>ADC resolution 14 bit</li>
                                <li>Wide band of 40 MHz</li>
                                <li>Up to 20 seconds of continuous acquisition</li>

                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DL950
